module.exports = __webpack_public_path__ + "img/interest.d0c09445.svg";